export default {
  ACTION_TYPE: 'actionType',
  SOURCE_PROPERTY: 'sourceProperty',
  TARGET_PROPERTY: 'targetProperty',
  TARGET_OBJECT: 'targetObject'
};